import {Modal} from 'react-bootstrap'
import {connect} from 'react-redux'
import {cancelResendEmail} from 'actions/reports/transactions'
import {Field, reduxForm} from 'redux-form'
import EmailField from './EmailField'
import modalStyles from 'components/Modal/Modal.css'
import styles from './resendEmailModal.css'
import validator from 'validator'

const validate = values => {
  const errors = {}
  if (!values.email) {
    errors.email = 'The email address is required'
  } else if (!validator.isEmail(values.email)) {
    errors.email = 'The value is not a valid email address'
  }
  return errors
}

class ResendEmailModal extends React.Component {
  render () {
    let {openResendEmailModal} = this.props.data.reports.transactions
    const {invalid} = this.props

    if (openResendEmailModal) {
      $('.modal-backdrop.fade').css('z-index', '1056')
      $('.modal-dialog-resend-receipt').parent().css('z-index', '1057')
    }

    return (<div>
      <Modal show={openResendEmailModal} onHide={this._onHide} bsClass='modal' dialogClassName={`modal-dialog-resend-receipt modal-dialog ${styles.dialog}`}>
        <Modal.Header>
          <Modal.Title bsClass={`modal-title ${modalStyles['modal-title']}`}>Resend Email</Modal.Title>
        </Modal.Header>
        <form onSubmit={this.props.handleSubmit}>
          <Modal.Body>
            <div className='row'>
              <div className='col-md-12'>
                <div className='form-group'>
                  <Field
                    component={EmailField}
                    name='email'
                    type='text'
                    placeholder='Email'
                    autoCorrect='off'
                    maxLength='40'
                    autoCapitalize='off'
                    spellCheck='false'
                    className='form-control'
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className={styles.footer}>
            <span className='pull-right'>
              <button className='btn btn-default mr-10px' onClick={this._onHide} type='button'>Cancel</button>
              <button className='btn btn-primary' type='submit' disabled={invalid}>Send</button>
            </span>
          </Modal.Footer>
        </form>
      </Modal>
    </div>)
  }
  _onHide = () => {
    $('.modal-backdrop').css('z-index', '499')
    $('.modal-dialog-resend-receipt').parent().css('z-index', '1057')
    const {transactionDetail} = this.props.data.reports.transactions
    this.props.dispatch(cancelResendEmail(transactionDetail))
  }
}

function mapStateToProps (state) {
  // only fetch some state
  return {
    data: {
      reports: {
        transactions: state.reports.transactions
      }
    }
  }
}

ResendEmailModal.propTypes = {
  dispatch: React.PropTypes.func,
  onSubmit: React.PropTypes.func
}

const mapFormValidation = {
  form: 'resendEmailForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate
}

export default reduxForm(mapFormValidation)(connect(mapStateToProps)(ResendEmailModal))



// WEBPACK FOOTER //
// ./app/components/receipt/transactions/ResendEmailModal/ResendEmailModal.js